// extracted by mini-css-extract-plugin
export default {"buttons-row":"sharepopup_buttons-row__4LTLN","submit-btn":"sharepopup_submit-btn__g-DAr","cancel-btn":"sharepopup_cancel-btn__wQjJ6"};